module.exports = __webpack_public_path__ + "img/telegram.a690c10f.svg";